import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-grouped-header-columns',
  standalone: true,
  imports: [],
  templateUrl: './grouped-header-columns.component.html',
  styleUrl: './grouped-header-columns.component.scss'
})
export class GroupedHeaderColumnsComponent {
  columns = input.required<Array<string>>();
  widths = input<Array<number>>([]);
  isColumnOpen = model<boolean>(true);
  columnName = input<string>('');
  openColumn = output<void>();
  closeColumn = output<void>();

  protected handleButtonClick(event: Event): void {
    event.stopPropagation();

    if (this.isColumnOpen()) {
      this.isColumnOpen.set(false);
      this.closeColumn.emit();
    } else {
      this.isColumnOpen.set(true);
      this.openColumn.emit();
    }
  }

  protected handleWrapperClick(): void {
    if (this.isColumnOpen()) { return; }

    this.isColumnOpen.set(true);
    this.openColumn.emit();
  }
}
